import React, { useEffect, useState } from 'react';

import { createPostRequest } from "Utils/Common";

import { message } from 'antd';
import { useParams, useNavigate } from "react-router-dom";

import {
    Button,
    Card,
    CardBody,
    CardGroup,
    Col,
    Container,
    Form,
    FormFeedback,
    Input,
    InputGroup,
    InputGroupText,
    Row
} from 'reactstrap';

import { useAuth, useTranslation } from "contexts";

const Login = ({ ...props }) => {
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(null);

    const { auth, setAuth } = useAuth();
    const { token } = useParams();
    const navigate = useNavigate();
    const translate = useTranslation();

    const [ messageApi, contextHolder ] = message.useMessage();

    const [ credentials, setCredentials ] = useState({
        username: '',
        password: ''
    });

    const onChange = ({ name, value }) => {
        setCredentials(oldVal => ({...oldVal, [name]:value}));
    }

    useEffect(() => {
        if( !token ) return ;
        createPostRequest('verify_accessToken', {token, path: 'a'})
            .then(resp => resp.data)
            .then(resp => {
                if( !resp.success ){
                    if( resp.redirect ){
                        return navigate(resp.redirect, { replace: true });
                    }
                    if( resp.error ) messageApi.open({ type: 'error', content: translate(resp.error) });
                    return navigate('/login', { replace: true });
                }

                setAuth(prevVal => ({ ...prevVal, isAuth: resp.success }));
                navigate(resp.redirect, { replace: true });
            })
            .catch(err => console.log(err))
    }, [token, navigate]);

    const handleLogin = () => {
        const { username, password } = credentials;

        if( !username.trim() || !password.trim() ){
            setError("Tous les champs devraient être remplis");
            return ;
        }

        setLoading(true);

        createPostRequest('login', { username, password })
            .then(resp => resp.data)
            .then(resp => {
                setLoading(resp.success === true);
                setError(resp.success === true ? null : "Nom d'utilisateur ou mot de passe incorrect") ;
                setAuth(prevVal => ({ ...prevVal, isAuth: resp.success }));
            })
            .catch(err => setLoading(false))
    } ;

    return (
        <>
            { contextHolder }
            {
                auth.isAuth !== true
                ?
                    <Container style={{ height: 'calc(100% - 30px)' }}>
                        <Row className="h-100 justify-content-center align-items-center">
                            <Col md="8">
                                <CardGroup>
                                    <Card className="p-4">
                                        <CardBody>
                                            <Form>
                                                <h1>{ translate("LogAuthentification") }</h1>
                                                <p className="text-muted">{ translate("LogLoginToYourAccount") }</p>
                                                <InputGroup className="mb-3">
                                                    <InputGroupText>
                                                        <i className="icon-user"/>
                                                    </InputGroupText>
                                                    <Input name="username" type="text" invalid={error !== null} placeholder={ translate("LogUsername") } value={credentials.username}
                                                        onChange={({ currentTarget }) => onChange(currentTarget)} autoComplete="new-username" />
                                                    <FormFeedback>{error}</FormFeedback>
                                                </InputGroup>
                                                <InputGroup className="mb-4">
                                                    <InputGroupText>
                                                        <i className="icon-lock"/>
                                                    </InputGroupText>
                                                    <br />
                                                    <Input name="password" type="password" invalid={error !== null} placeholder={ translate("LogPassword") } value={credentials.password}
                                                        onChange={({ currentTarget }) => onChange(currentTarget)} autoComplete="new-password" />
                                                    <FormFeedback>{error}</FormFeedback>
                                                </InputGroup>
                                                <Row>
                                                    <Col xs="6">
                                                        <Button 
                                                            color="primary" 
                                                            className="px-4" 
                                                            value={loading ? 'Loading...' : 'Login'}
                                                            onClick={handleLogin} 
                                                            disabled={loading}
                                                        >
                                                            { translate("LogLogin") }
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </CardBody>
                                    </Card>
                                </CardGroup>
                            </Col>
                        </Row>
                    </Container>
                :
                    null
            }
        </>
    );
}

export default Login;